<template>
  <div
    v-if="noteDisplay !== 'list'"
    :class="{ 'form-group': !noteIsActionModal }"
  >
    <div :class="{ 'ak-modal__body pt-none': noteIsActionModal }">
      <textarea
        v-model="newNote"
        rows="2"
        placeholder="Add your note"
        class="form-control mb-tiny"
      ></textarea>
    </div>
    <div :class="{ 'ak-modal__footer': noteIsActionModal }">
      <ak-button
        :class="{ 'ak-modal__footer-item ak-btn--large': noteIsActionModal }"
        color="primary"
        :disabled="!newNote || !newNote.length"
        @click.prevent="addNote(newNote)"
      >
        Add Note
      </ak-button>
    </div>
  </div>
  <div v-if="noteDisplay !== 'form'">
    <div
      v-for="(note, key) in notesList.slice().reverse()"
      :key="key"
      class="mb-small"
    >
      <ak-card v-if="noteTheme !== 'grey'" class="text-breakall">
        <ak-card-body>
          {{ note.content }}
        </ak-card-body>
      </ak-card>
      <ak-box v-else background="grey-lightest" rounded>
        {{ note.content }}
      </ak-box>
      <div class="text-small text-right mt-tiny">
        {{ fromNow(note.createdOn) }}, by {{ note.author }}
      </div>
    </div>
    <ak-empty-state
      v-if="!noteItem.notes.length"
      title="No notes yet"
      icon="document"
    >
    </ak-empty-state>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { request } from '@akerolabs/akero-vue/src/utils/request'
import { ToastProgrammatic } from '@akerolabs/akero-vue/src/components/toast'
import { fromNow } from '@akerolabs/akero-vue/src/filters/date'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import Card from '@akerolabs/akero-vue/src/components/cards/Card.vue'
import CardBody from '@akerolabs/akero-vue/src/components/cards/CardBody.vue'
import Box from '@akerolabs/akero-vue/src/components/box/Box.vue'
import EmptyState from '@akerolabs/akero-vue/src/components/emptyState/EmptyState.vue'

export default defineComponent({
  name: 'AkDocumentNotes',
  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [Button.name]: Button,
    [Card.name]: Card,
    [CardBody.name]: CardBody,
    [Box.name]: Box,
    [EmptyState.name]: EmptyState,
  },
  inheritAttrs: false,
  props: {
    /**
     * @type {Object}
     * @description What item the notes are for
     */
    noteItem: {
      type: Object,
      default: () => {},
    },
    /**
     * @type {String}
     * @description What type the notes are for
     */
    noteType: {
      type: String,
      default: undefined,
    },
    /**
     * @type {String}
     * @description Whether to display list, form or both
     */
    noteDisplay: {
      type: String,
      default: 'both',
    },
    /**
     * @type {Boolean}
     * @description Is it in a model or not
     */
    noteIsActionModal: {
      type: Boolean,
      default: false,
    },
    /**
     * @type {String}
     * @description Theme style
     */
    noteTheme: {
      type: String,
      default: undefined,
    },
  },

  setup(props) {
    const notesList = ref(props.noteItem.notes)
    const newNote = ref('')

    /**
     * @param {Object} newNote
     * @description
     */
    const addNote = async (noteData) => {
      try {
        const { data } = await request.post(
          `/notes/${props.noteType}/${props.noteItem._id}`,
          { note: noteData },
        )
        notesList.value.push(data.data)
        ToastProgrammatic.open({
          message: 'Note has been created',
          type: 'success',
        })
      } catch (ex) {
        ToastProgrammatic.open({
          message: 'Error note could not be created',
          type: 'danger',
        })
      }
      newNote.value = ''
    }

    return {
      fromNow,
      notesList,
      addNote,
      newNote,
    }
  },
})
</script>
